










import { Vue2PageContainer } from './vue2_page_container';
import {Vue2EndMarker} from './vue2_end_marker';
import { Vue2EndDetector } from './vue2_end_detector';
import { Vue2ReportPrinter } from './vue2_report_printer';
import { ContentProvider } from '../domain/content_provider';
import { ReportEngine } from '../app/report_engine';
import ReportPage from './ReportPage.vue';
import Vue from 'vue';
export default {
    name: 'ReportWrapper',
    props: {
        contentProvider:{
            type: Object,
            required: true,
        },
        reportPromise:{
            type: Promise,
            required: false,
            default() {
                return Promise.resolve();
            } 
        },
    },
    components: {
        ReportPage,
    },
    data() {
        return {
            pageContainer: null,
            endMarker: null,
            reportPrinter: null,
            endDetector: null,
            reportEngine: null,
        };
    },
    async mounted() {
        this.pageContainer = new Vue2PageContainer();
        this.endMarker = new Vue2EndMarker();
        this.reportPrinter = new Vue2ReportPrinter();
        this.endDetector = new Vue2EndDetector()
        this.reportEngine = new ReportEngine(this.contentProvider as ContentProvider,this.pageContainer,this.endDetector,this.endMarker,this.reportPrinter,10)
        try {
            await this.reportPromise
            await Vue.nextTick()
            await this.reportEngine.generateReport()
        } catch (error) {
            console.error('ReportWrapper mounted error:', error)
            // Fallback: ensure end marker is enabled even if initialization fails
            if (this.endMarker) {
                this.endMarker.enable()
            }
        }
    },
};
